import { ReturnBaseUrl } from '@/network/request'

/** Shared server/account cache identity. Old region-ID invalidation scheduling was replaced
 * by visible-region-refresh. Keep this export stable for existing cache consumers.
 * Server mutation metadata remains available to mobile clients until their migration. */
export function getControlDataInvalidationScopeKey(vm) {
  const server = ReturnBaseUrl()
  const userId =
    vm && vm.$store ? vm.$store.state.userinfo.userId || sessionStorage.getItem('userId') : ''
  return encodeURIComponent(String(server || '')) + ':' + String(userId || 'unknown')
}
